import styled from '@emotion/styled';

import { Label } from '../../layouts';

export const RadioButtonLabel = styled(Label)`
    &&& {
        padding-left: 0;
    }
`;
